<div class="ai-wrapper" [class.fullscreen]="fullscreen">
  <button
    class="btn btn-close-fs-modal"
    *ngIf="fullscreen"
    title="Close"
    aria-label="close"
    (click)="toggleFullscreen()">
    <i class="bi bi-x-lg"></i>
  </button>
  <div class="card border-0" [class.fullscreen]="fullscreen">
    <div class="ai-header">
      <div class="ai-header-logo">
        <img
          src="/assets/icon-ai-assistant.svg"
          class="ai-icon"
          alt="AI Assistant" />
        <div>
          <h1>
            Smart Assistant<span class="fs-15 ms-1"
              ><i
                class="bi bi-info-circle-fill"
                ngbTooltip
                #t="ngbTooltip"
                [ngbTooltip]="userUploadTooltip"
                triggers="manual"
                (mouseenter)="t.open()"></i
            ></span>
          </h1>
        </div>
      </div>
      <ng-template #userUploadTooltip>
        <div class="p-2 pb-4" (mouseenter)="t.open()" (mouseleave)="t.close()">
          Remember to use AI responsibly, such as anonymizing student data.
          <a
            href="https://learn.growelab.app/en/articles/14048766-responsible-ai-use-guide"
            target="_blank"
            class="color-secondary">
            Learn more
          </a>
        </div>
      </ng-template>
      <div class="ai-header-btns" @fadeInOut>
        <button
          *ngIf="currentConversation"
          class="btn btn-text"
          (click)="resetConversation()">
          <i class="bi bi-plus me-1"></i>New Chat
        </button>
        <button class="btn btn-text" (click)="openPreviousChatsModal()">
          <i class="bi bi-search me-1"></i>Search Chats
        </button>
        <button
          aria-label="Fullscreen"
          class="btn btn-reset d-none d-xl-block"
          *ngIf="!fullscreen"
          (click)="toggleFullscreen()">
          <i class="bi bi-fullscreen fs-16"></i>
        </button>
      </div>
    </div>
    <div class="message-area" #messagesArea>
      <div class="grad-border"></div>
      <div
        class="tip-overlay"
        *ngIf="messages && messages.length === 0"
        @delayfadeInOut>
        💡 <strong>Tip</strong>: Attach images or documents, ask follow-up
        questions, or switch modes anytime
      </div>
      <div class="p-4">
        <ng-container *ngFor="let message of messages">
          <ng-container *ngIf="message.role === 'user'">
            <div class="message-wrapper d-flex justify-content-end">
              <div class="message user-message">
                <div class="message-content">
                  <markdown>{{ message.content }}</markdown>
                </div>
                <ng-container *ngFor="let file of message.files">
                  <div class="file-attachment">
                    {{ file.name }}
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="message.role === 'assistant'">
            <div class="message-wrapper">
              <div class="d-flex justify-content-start align-items-center">
                <div>
                  <img
                    src="/assets/icon-ai-assistant-sm.svg"
                    class="ai-icon me-4"
                    alt="AI Assistant" />
                </div>
                <div class="message ai-message">
                  <div *ngIf="message.thinking" class="thinking-content">
                    {{ message.thinking }}
                  </div>
                  <div class="message-content">
                    <markdown>{{ message.content }}</markdown>
                  </div>
                  <div *ngIf="message.isComplete" class="action-btns">
                    <app-ai-response-actions
                      [content]="message.content"
                      [userFeedback]="feedbackByMessageId[message.id] || null"
                      (thumbClicked)="onThumbClicked(message, $event)" />
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>

        <!-- Loading animation -->
        <div *ngIf="isLoading" class="message-wrapper" @fadeInOut>
          <div class="d-flex justify-content-start align-items-center">
            <div>
              <img
                src="/assets/icon-ai-assistant-sm.svg"
                class="ai-icon me-4"
                alt="AI Assistant" />
            </div>
            <div class="loading-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="glai-prompt-wrapper" @fadeInOut>
      <div class="row-prompt">
        <div class="mode-select" ngbDropdown #myDrop="ngbDropdown">
          <button
            type="button"
            aria-label="AI Mode"
            class="btn-reset btn-mode me-2 fs-20"
            id="dropdownManual"
            ngbDropdownAnchor
            (focus)="myDrop.open()">
            <i
              class="bi"
              [ngbTooltip]="selectedPath"
              [autoClose]="true"
              [ngClass]="currentClass"></i>
          </button>
          <div
            ngbDropdownMenu
            aria-labelledby="dropdownManual"
            class="dropdown-menu">
            <div class="fs-13 fw-700 label">AI MODE</div>
            <button
              ngbDropdownItem
              class="btn btn-ai-select"
              [class.active]="activeModes.includes('default')"
              (click)="toggleMode('default')">
              <i
                class="bi"
                [ngClass]="
                  activeModes.includes('default') ? 'bi-chat-fill' : 'bi-chat'
                "></i
              >Ask Anything (General)
            </button>
            <button
              ngbDropdownItem
              class="btn btn-ai-select"
              [class.active]="
                activeModes.includes('lesson_and_differentiation')
              "
              (click)="toggleMode('lesson_and_differentiation')">
              <i
                class="bi"
                [ngClass]="
                  activeModes.includes('lesson_and_differentiation')
                    ? 'bi-book-fill'
                    : 'bi-book'
                "></i
              >Lessons and Differentiation
            </button>
            <button
              ngbDropdownItem
              class="btn btn-ai-select"
              [class.active]="activeModes.includes('grading_and_feedback')"
              (click)="toggleMode('grading_and_feedback')">
              <i
                class="bi"
                [ngClass]="
                  activeModes.includes('grading_and_feedback')
                    ? 'bi-clipboard-check-fill'
                    : 'bi-clipboard-check'
                "></i
              >Grading and Feedback
            </button>
            <button
              ngbDropdownItem
              class="btn btn-ai-select"
              [class.active]="activeModes.includes('communication')"
              (click)="toggleMode('communication')">
              <i
                class="bi"
                [ngClass]="
                  activeModes.includes('communication')
                    ? 'bi-envelope-fill'
                    : 'bi-envelope'
                "></i
              >Professional Communication
            </button>
            <button
              ngbDropdownItem
              class="btn btn-ai-select"
              [class.active]="activeModes.includes('classroom_management')"
              (click)="toggleMode('classroom_management')">
              <i
                class="bi"
                [ngClass]="
                  activeModes.includes('classroom_management')
                    ? 'bi-person-fill-gear'
                    : 'bi-person-gear'
                "></i
              >Classroom Management
            </button>
            <!--
            <button
              ngbDropdownItem
              class="btn btn-ai-select"
              [class.active]="activeModes.includes('data_analysis')"
              (click)="toggleMode('data_analysis')">
              <i
                class="bi"
                [ngClass]="
                  activeModes.includes('data_analysis')
                    ? 'bi-bar-chart-fill'
                    : 'bi-bar-chart'
                "></i
              >Data Analysis
            </button>
            -->
          </div>
        </div>
        <div class="input-file">
          @if(uploadedFiles.length < 1) {
          <app-file-upload
            #uploadComponent
            [ngbTooltip]="'Attach File'"
            [uploadType]="uploadType"
            [style]="uploadStyle"
            (outputFiles)="addToFileList($event); fileUploads.emit($event)" />
          } @else {
          <div
            class="btn btn-reset btn-file-modal"
            (click)="fileMgmtModal.open()">
            <ng-container *ngIf="uploadedFiles">
              <div class="total-files" *ngIf="uploadedFiles.length > 0">
                {{ uploadedFiles.length }}
              </div>
            </ng-container>
            <i class="bi bi-paperclip"></i>
          </div>
          }
        </div>
        <textarea
          #textareaprompt
          class="areaprompt"
          rows="1"
          [disabled]="isLoading"
          [placeholder]="dynamicPlaceholder()"
          [(ngModel)]="userMessage"
          (ngModelChange)="resizeInput()"
          (keyup.enter)="sendMessage()"></textarea>
        <button
          aria-label="Send Message"
          class="btn btn-primary input-btn"
          (click)="sendMessage()"
          [disabled]="isLoading || !userMessage.trim()">
          <i *ngIf="!isLoading" class="bi bi-send"></i>
          <i *ngIf="isLoading" class="bi bi-hourglass-split"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal
  #fileMgmtModal
  [modalConfig]="{
    titleText: 'Attachments',
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    customFooter: true,
    options: { size: 'md' }
  }">
  <button
    class="btn btn-closemodal"
    title="Close"
    aria-label="close"
    headerContent
    (click)="fileMgmtModal.close()">
    <i class="bi bi-x-lg text-white"></i>
  </button>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="my-3 fs-14">
          <ng-container *ngIf="uploadedFiles">
            <div
              *ngIf="uploadedFiles.length > 0"
              class="modal-file-list-wrapper">
              <app-file-list
                (deletedFile)="
                  removeFromFileList($event); fileMgmtModal.close()
                "
                [fileList]="uploadedFiles"></app-file-list>
            </div>
          </ng-container>
          <app-file-upload
            #uploadComponent
            [ngbTooltip]="'Attach File'"
            [uploadType]="uploadType"
            [style]="modalUploadStyle"
            (outputFiles)="addToFileList($event); fileUploads.emit($event)" />
        </div>
      </div>
    </div>
  </div>
  <div class="w-100 d-flex justify-content-end" footerContent>
    <button (click)="fileMgmtModal.close()" class="btn btn-reset">Done</button>
  </div>
</app-modal>

<app-glai-previous-chats-modal
  #previousChatsModal
  (conversationSelected)="
    onConversationSelected($event)
  "></app-glai-previous-chats-modal>
